<div class="confirm-dialog">
  <div class="confirm-dialog__content">
    <p *ngIf="message">{{ message }}</p>
    <p *ngIf="!message">
      Are you sure you want to restart Alex? <br />
      This will clear all your chat history.
    </p>
    <div class="confirm-dialog__actions">
      <button 
      mat-stroked-button class="restart-btn" 
      (click)="onRestartClick()"
       [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font || configs?.fonts?.default_font,
              }"
      >
        Restart
      </button>
      <button
        *ngIf="showCancel"
        mat-stroked-button
        class="primary-btn"
        (click)="onCancelClick()"
        [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font || configs?.fonts?.default_font,
              }"
      >
        Cancel
      </button>
    </div>
  </div>
</div>
